import React from 'react';
import PropTypes from 'prop-types';
import { Button, Paper, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

// COMPONENTS
import CardBrandIcon from '@/components/Payment/CardBrandIcon';

// UTILITY
import { getSecureCardNumberValue } from '@/utility/subscription';

function CreditCardPlaceholder({ data, onChangeCard }) {
  const [t] = useTranslation();

  const { name, last4, brand } = data;
  const cardNumber = getSecureCardNumberValue(last4);

  return (
    <Paper className="credit-card-placeholder">
      <div className="credit-card-placeholder__info">
        <Typography variant="h6" className="credit-card-placeholder__title">
          {cardNumber} <CardBrandIcon brand={brand} className="brand-icon" />
        </Typography>
        {name && <Typography className="p5 bank-name">{name}</Typography>}
      </div>
      <Button variant="text" size="small" onClick={onChangeCard}>
        {t('buttons.changeCard')}
      </Button>
    </Paper>
  );
}

CreditCardPlaceholder.propTypes = {
  onChangeCard: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
};

export default React.memo(CreditCardPlaceholder);
